/** @format */

import {useMemo} from 'react';

import {format} from 'date-fns';

import {useGetYandexHistoryQuery, useGetCurrentUserQuery} from '../graphql/__generated__';
import {transformYandexHistoryData} from '../helpers/transformYandexHistoryData';

interface UseYaDirectDataProps {
  startDate: Date;
  endDate: Date;
}

export const useYaDirectData = ({startDate, endDate}: UseYaDirectDataProps) => {
  const {
    loading: currentUserLoading,
    error: currentUserError,
    data: currentUserData,
  } = useGetCurrentUserQuery();

  const {data, loading, error} = useGetYandexHistoryQuery({
    variables: {
      timeFrom: format(startDate, 'yyyy-MM-dd HH:mm:ss'),
      timeTo: format(endDate, 'yyyy-MM-dd HH:mm:ss'),
      projectUuid: currentUserData?.currentUser?.currentCompany?.uuid || '',
    },
    skip: !currentUserData?.currentUser?.currentCompany?.uuid,
  });

  const tableData = useMemo(() => {
    return transformYandexHistoryData(data?.currentUser?.yandexHistory);
  }, [data?.currentUser?.yandexHistory]);

  return {
    currentUserData,
    tableData,
    loading: currentUserLoading || loading,
    error: error || currentUserError,
  };
};
